(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name flightBlockTimeReport.controller:FlightBlockTimeReportCtrl
	 * 
	 * @description
	 * 
	 */
	angular.module('flightBlockTimeReport').controller(
			'FlightBlockTimeReportCtrl', FlightBlockTimeReportCtrl);

	function FlightBlockTimeReportCtrl(CommonMasterData, $sce,
			CommonLogicService) {
		var vm = this;
		vm.ctrlName = 'FlightBlockTimeReportCtrl';
		// report types
		vm.reportTypes = {
			BY_PAX : 'BY_PAX',
			BY_BLOCK_TIME : 'BY_BLOCK_TIME'
		}

		vm.model = {
			searchPanelToggle : true,
			defaultCarrier : null,
			searchCriteria : {
				fromDate : null,
				toDate : null,
				fromTime : '00:00',
				toTime : '23:59',
				origin : null,
				destination : null,
				flightStatus : null,
				diverted : null,
				depTaxiTime : null,
				arrTaxiTime : null,
				reportType : false,
				carriers : null
			},
			masterList : {
				airportList : [],
				flightStatusList : [],
				divertedStatusList : [],
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false,
				fromDateAfterToDate : false,
				fromTimeInvalid : false,
				toTimeInvalid : false,
				carriers : []
			},
			initialSearchDone : false,
			reportDataURL : null,
			reportServerBaseUrl : null
		};

		// toggle search
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// submit search
		vm.submitSearch = function(params) {
			searchFlightBlockTimeReport(params);
		};

		// when change field in search
		vm.changeSearchField = function(searchParams, flag) {
			setDateValidationFlags();
			// if from date time before to date time
			if (!!vm.model.searchCriteria.fromDate
					&& !!vm.model.searchCriteria.fromTime
					&& !!vm.model.searchCriteria.toDate
					&& !!vm.model.searchCriteria.toTime
					&& !vm.model.masterList.fromDateFormatInvalid
					&& !vm.model.masterList.toDateFormatInvalid
					&& !vm.model.masterList.fromTimeInvalid
					&& !vm.model.masterList.toTimeInvalid
					&& !isFromDateBeforeToDate()) {
				vm.model.masterList.fromDateAfterToDate = true;
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
			}
		};

		function setDateValidationFlags() {
			// if from date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
				vm.model.masterList.fromDateFormatInvalid = true;
			} else {
				vm.model.masterList.fromDateFormatInvalid = false;
			}
			// if to date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
				vm.model.masterList.toDateFormatInvalid = true;
			} else {
				vm.model.masterList.toDateFormatInvalid = false;
			}
			// if from time invalid
			if (!isValidTime(vm.model.searchCriteria.fromTime)) {
				vm.model.masterList.fromTimeInvalid = true;
			} else {
				vm.model.masterList.fromTimeInvalid = false;
			}
			// if from time invalid
			if (!isValidTime(vm.model.searchCriteria.toTime)) {
				vm.model.masterList.toTimeInvalid = true;
			} else {
				vm.model.masterList.toTimeInvalid = false;
			}
		}

		// check from date and to date
		function isFromDateBeforeToDate() {
			return moment(
					vm.model.searchCriteria.fromDate + " "
							+ vm.model.searchCriteria.fromTime,
					"DD/MM/YYYY HH:mm").isBefore(
					moment(vm.model.searchCriteria.toDate + " "
							+ vm.model.searchCriteria.toTime,
							"DD/MM/YYYY HH:mm"));
		}
		;
		// validate Date
		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
			return false;
		}

		// validate time
		function isValidTime(time) {
			var regex = /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/;
			return regex.test(time);
		}
		;

		// search Flight Block Time report
		function searchFlightBlockTimeReport(param) {
			vm.model.initialSearchDone = true;
			if (isValidSearchParams(param)) {
				vm.model.searchCriteria = param;
				vm.model.searchPanelToggle = false;
				var reportType = getReportType(param.reportType);
				var reportDesign = "";
				switch (reportType) {
				case "BY_PAX":
					reportDesign = 'flight_blk_time_by_pax_report.rptdesign';
					break;
				case "BY_BLOCK_TIME":
					reportDesign = 'flight_block_time.rptdesign';
					break;
				}
				var url = CommonLogicService.getReportUrl(reportDesign,
						getSearchParamMap(param));
				vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
			}
		}

		// set search param map
		function getSearchParamMap(param) {
			var searchParamMap = {};
			searchParamMap["fromDate"] = param.fromDate;
			searchParamMap["toDate"] = param.toDate;
			searchParamMap["fromTime"] = param.fromTime;
			searchParamMap["toTime"] = param.toTime;
			searchParamMap["origin"] = '';
			if (!!param.origin && !!param.origin.airPortCode) {
				searchParamMap["origin"] = param.origin.airPortCode;
			}
			searchParamMap["destination"] = '';
			if (!!param.destination && !!param.destination.airPortCode) {
				searchParamMap["destination"] = param.destination.airPortCode;
			}
			searchParamMap["flightStatus"] = '';
			if (!!param.flightStatus && !!param.flightStatus.flightStatusCode) {
				searchParamMap["flightStatus"] = param.flightStatus.flightStatusCode;
			}
			searchParamMap["diverted"] = '';
			if (!!param.diverted && !!param.diverted.divertedStatusCode) {
				searchParamMap["diverted"] = param.diverted.divertedStatusCode;
			}
			searchParamMap["depTaxiTime"] = '';
			if (!!param.depTaxiTime) {
				searchParamMap["depTaxiTime"] = param.depTaxiTime;
			}
			searchParamMap["arrTaxiTime"] = '';
			if (!!param.arrTaxiTime) {
				searchParamMap["arrTaxiTime"] = param.arrTaxiTime;
			}
			
			searchParamMap["carrier"] = '';
			if (!!param.carriers && !!param.carriers.code) {
			    searchParamMap["carrier"] = param.carriers.code;
			}
			return searchParamMap;
		}

		function getReportType(reportType) {
			if (reportType) {
				return vm.reportTypes.BY_BLOCK_TIME;
			} else {
				return vm.reportTypes.BY_PAX;
			}
		}
		function isValidSearchParams(params) {
			setDateValidationFlags();
			// if date invalid
			if (!!vm.model.searchCriteria.fromDate
					&& !!vm.model.searchCriteria.fromTime
					&& !!vm.model.searchCriteria.toDate
					&& !!vm.model.searchCriteria.toTime) {
				if (vm.model.masterList.toDateFormatInvalid
						|| vm.model.masterList.fromTimeInvalid
						|| vm.model.masterList.fromDateFormatInvalid
						|| vm.model.masterList.toTimeInvalid
						|| vm.model.masterList.fromDateAfterToDate) {
					return false;
				} else {
					return true;
				}
			}
			return false;
		}

		(function() {
			// load airport list
			CommonMasterData.getAirportList(function(airportList) {
				vm.model.masterList.airportList = airportList;
			}, function(error) {
				console.log('Airport List retrieval error!!!');
			});
			// load Flight Status list
			CommonMasterData.getFlightStatusList(function(flightStatusList) {
				vm.model.masterList.flightStatusList = flightStatusList;
			}, function(error) {
				console.log('Flight Status List retrieval error!!!');
			});// divertedList
			// load Flight Status list
			CommonMasterData
					.getDivertedStatusList(
							function(divertedStatusList) {
								vm.model.masterList.divertedStatusList = divertedStatusList;
							},
							function(error) {
								console
										.log('Diverted Status List retrieval error!!!');
							});
			
			CommonMasterData.searchCarriers( 
					function (response) {
					  for(var index in response.hubCodes) {
					      vm.model.masterList.carriers.push({"code":response.hubCodes[index],"name":response.hubCodes[index]});
					  }
					  vm.model.defaultCarrier = response.clientCode;
					},
					function (error) {
						 MessageService.error(error);
					}
			);
			
		})();
	}
}());